import Api from "./http.js";
import i18n from "@/plugins/language/i18n";
class HttpModalResourcesService {
    prefix = 'superUp/admin/modal-resources';

    api = Api.create();

    token = null;
    getProviders(id)
    {
        return this.api.get(`${this.prefix}/providers/${id}`);
    }

    getProducts(params) {
        return this.api.get(`${this.prefix}/products/`, {params: params});
    }

    getBrands(params) {
        return this.api.get(`${this.prefix}/brands/`, {params: params});
    }

}

export default new HttpModalResourcesService();
